module.exports = __webpack_public_path__ + "static/media/hdb-back.c1cbc037.png";